module.exports = __webpack_public_path__ + "img/corporate-competition-2024-schedule-men-finals-2.c8f2c0eb.png";